import { render } from "./ClearanceCertificates.vue?vue&type=template&id=cea8a97a&scoped=true"
import script from "./ClearanceCertificates.vue?vue&type=script&lang=js"
export * from "./ClearanceCertificates.vue?vue&type=script&lang=js"

import "./ClearanceCertificates.vue?vue&type=style&index=0&id=cea8a97a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cea8a97a"]])

export default __exports__